import gql from 'graphql-tag';

export default gql `
query listActivitiesByUser($username: String){
    listActivitiesByUser(username: $username) {
			items {
				id
				username
				date
				activityType
				value
				intensity
				notes
			}
	}	
}`;


// WEBPACK FOOTER //
// ./src/components/queries/ListActivitiesUserQuery.js